export class CFSSAgencyBO {
    id: string="00000000-0000-0000-0000-000000000000";
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    fax: string;
    phone: string;
    email: string;
    agencyId: string;
    languageLid: string[];
} 








 